export const DATADOG_BUILD_TAG_KEY = 'build_tag';

// Property reads only: a bare import.meta.env makes Vite inline the whole env object.
export const getDatadogVersion = (): string | undefined =>
  [
    import.meta.env.PUBLIC_RELEASE_VERSION,
    import.meta.env.PUBLIC_BUILD_TAG,
  ].find(Boolean);
